//用户
import axios from "axios"
export default {
    loginAsync: async (data) => {//登录
        return axios.post('/login', data)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    regAsync: async (data) => {//注册
        return axios.post('/register', data)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    sendCodeAsync: async (data) => {//发送验证码
        return axios.post('/send_sms_code', data)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    findPwdAsync: async (data) => {//找回密码
        return axios.post('/edit_pws_code', data)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    getCurrentUserAsync: async () => {//获取当前登录用户信息
        return axios.get('/get_login_info')
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    editUserAsync: async (data) => {//修改用户信息
        return axios.post('/edit_login_info', data)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    editPwdAsync: async (data) => {//修改密码
        return axios.post('/edit_login_pwd', data)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    visitOtherAsync: async (params) => {//获取当前登录用户信息
        return axios.get('/get_look_info', { params: params })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    getJoinAsync: async (params) => {//获取我参与的评审
        return axios.get('/join_invite', { params: params })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    getWorksAsync: async (params) => {//获取我的作品
        return axios.get('/my_opus', { params: params })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    getRevieweAsync: async (params) => {//获取我的评审
        return axios.get('/join_invite', { params: params })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
}
